import { render, staticRenderFns } from "./PartnerBadge.vue?vue&type=template&id=7e0d0280"
import script from "./PartnerBadge.vue?vue&type=script&lang=js"
export * from "./PartnerBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports